import React from "react";
import propTypes from "prop-types";
import AnsQuestionComponents from "../AnsQuestionComponents";
import classNames from "classnames";
import { useStyles } from "./styles";
import { CheckSvgIcn } from "svgIcon";
const QuestionComponents = ({ questionData }) => {
  const classes = useStyles();
  return (
    <>
      <div
        className={classNames(
          classes.timeline,
          "timelineCommon position-relative mt-4"
        )}
      >
        {questionData?.length
          ? questionData.map((item, i) => {
              return (
                <>
                  <div className="timel__items position-relative" key={i}>
                    <div className="timel__num position-absolute bg-light rounded-pill fw-semibold d-flex align-items-center justify-content-center">
                      {i + 1}
                    </div>
                    <div className="timel__content">
                      <div className="timel__head fw-bold text-dark mb-2">
                        {/* 5 = checkboxText (questiontype) */}
                        {item.question_type === 5 ? (
                          <div className="d-flex">
                            <CheckSvgIcn /> {item.question}
                          </div>
                        ) : (
                          item.question
                        )}
                      </div>
                      <div className="timel__body">
                        <AnsQuestionComponents questionData={item} />
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          : ""}
      </div>
    </>
  );
};
QuestionComponents.propTypes = {
  history: propTypes.object,
};
export default QuestionComponents;
